import { render, staticRenderFns } from "./CardInterior.vue?vue&type=template&id=e89702d0&scoped=true"
import script from "./CardInterior.vue?vue&type=script&lang=js"
export * from "./CardInterior.vue?vue&type=script&lang=js"
import style0 from "./CardInterior.vue?vue&type=style&index=0&id=e89702d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89702d0",
  null
  
)

export default component.exports